
      import API from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-1.use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-1.use[2]!../../../../node_modules/resolve-url-loader/index.js??clonedRuleSet-1.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-1.use[4]!../../../../node_modules/sass-resources-loader/lib/loader.js??clonedRuleSet-1.use[5]!./TabsLayout.scss?vue&type=custom&index=0&blockType=scss&issuerPath=C%3A%5CBuildAgent%5Cwork%5C80844fdc646ab6fa%5Csrc%5Cresources-vue%5Cvue-custom-elements%5CTabsLayout%5CTabsLayout.vue&external";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-1.use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-1.use[2]!../../../../node_modules/resolve-url-loader/index.js??clonedRuleSet-1.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-1.use[4]!../../../../node_modules/sass-resources-loader/lib/loader.js??clonedRuleSet-1.use[5]!./TabsLayout.scss?vue&type=custom&index=0&blockType=scss&issuerPath=C%3A%5CBuildAgent%5Cwork%5C80844fdc646ab6fa%5Csrc%5Cresources-vue%5Cvue-custom-elements%5CTabsLayout%5CTabsLayout.vue&external";
       export default content && content.locals ? content.locals : undefined;
